import "./App.css";
import Index from "./pages/index";
import AdminEntry from "./components/AdminEntry";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <Router>
      <AdminEntry><Index /></AdminEntry>
    </Router>
  );
}

export default App;
